import axios from 'axios';
import Environment from '../../buyer-experience/common/environment';
import stgConfig from '../../../../config';
import Logger from '../../buyer-experience/common/logger';
import storage from "../../utils/storage";

export default class IntercomWidget {
    domRoot: any;
    params: any;
    logger: Logger;

    constructor(domRoot: HTMLElement, params: any) {
        this.domRoot = domRoot;
        this.params = params;
        this.logger = new Logger();
        this.init();
    }

    init() {
        
        if(document.documentElement.lang == 'ja') {
            return;
        }

        if(window.initializeATLAnalyticsTriggered) {
            this.onLoadWidget();
        } else {
            document.addEventListener(
                "onLoadExternalJSATLAnalytics",
                () => {
                    this.onLoadWidget();
                },
                false,
            );
        }
    }

    async onLoadWidget() {
        const {
            intercomAppId,
            isIncludeAnonymousId,
            isIncludeUserInfo
        } = this.params;

        const environment = Environment.getEnvironment();
        const STAGING_ENDPOINT = `${window.location.hostname.indexOf('qa-wac') > -1 ? 'https://qa-wac.internal.atlassian.com' : stgConfig.stgWacInternalUrl}`;
        const BXP_EXPRESS_ENDPOINT = {
            [Environment.production()]: 'https://www.atlassian.com',
            [Environment.staging()]: STAGING_ENDPOINT,
            [Environment.dev()]: STAGING_ENDPOINT,
        };

        const intercomSettings: {
            app_id: string,
            anonymousId?: string,
            name?: string,
            email?: string,
        } = {
            app_id: intercomAppId
        };

        const anonId = storage.getCookie("ajs_anonymous_id") || "";

        if (isIncludeAnonymousId && anonId) {
            intercomSettings['anonymousId'] = anonId;
        }

        if (isIncludeUserInfo) {
            try {
                const gatewayApiMeGetResponse = await axios.get(BXP_EXPRESS_ENDPOINT[environment] + '/gateway/api/me');
                // @ts-ignore
                const gatewayApiMeGetResponseResult = gatewayApiMeGetResponse.json();
                if (gatewayApiMeGetResponseResult) {
                    intercomSettings['name'] = gatewayApiMeGetResponseResult.name;
                    intercomSettings['email'] = gatewayApiMeGetResponseResult.email;
                }
            } catch (e) {
                // @ts-ignore
                this.logger.log('error while gettin making get request to /gateway/api/me: ' + e.message);
            }
        }

        // @ts-ignore
        window.Intercom('boot', {
            ...intercomSettings
        });

        // @ts-ignore
        window.Intercom('trackEvent', 'widget-loaded');
    }
}
